import React from 'react';
import { VerifyPasswordEntry } from '../verifyPassword/VerifyPasswordEntry';
import { TOTPVerificationForm } from '../../../../shared/totpVerificationForm/TOTPVerificationForm';
import { useSteps } from '@workday/upc-common';
import { ConfirmDeleteEntry } from './ConfirmDeleteEntry';
import { useVerifyTotpMutation } from '../../../../slices/account-api.slice';

export function DeleteAccountSteps({ onClose }) {
    const { next, currentStep } = useSteps();

    const [verifyTotp, verifyTotpMutation] = useVerifyTotpMutation();

    function onSubmit(payload) {
        verifyTotp({
            passcode: payload.passcode,
            operation: 'gdpr-delete'
        });
    }

    return currentStep === 0 ? (
        <VerifyPasswordEntry onClose={onClose} onNext={next} operation='gdpr-delete' />
    ) : currentStep === 1 ? (
        <TOTPVerificationForm mutation={verifyTotpMutation} onSubmit={onSubmit} onNext={next} onCancel={onClose} />
    ) : currentStep === 2 ? (
        <ConfirmDeleteEntry onClose={onClose} />
    ) : null;
}
